import React, { useEffect, useState, ReactNode } from "react";
import { checkServerStatus } from "../../cores/utils";
import { useSocketCore } from "../../cores/socket";

const useServerStatus = (statusUrl: string) => {
  const [apiReachable, setApiReachable] = useState<boolean | null>(null);
  const { disconnected, setDisconnected } = useSocketCore();

  /** HTTP probe only — independent of WebSocket state (socket must not wipe or reset this flag). */
  useEffect(() => {
    let cancelled = false;

    const run = () =>
      checkServerStatus(statusUrl, (online) => {
        if (!cancelled) setApiReachable(online);
      });

    run();
    const slowPoll = window.setInterval(run, 60_000);

    return () => {
      cancelled = true;
      window.clearInterval(slowPoll);
    };
  }, [statusUrl]);

  /** Recover socket flag when API is up; does not touch apiReachable (avoids loading/offline races). */
  useEffect(() => {
    if (!disconnected) return;

    const run = () =>
      checkServerStatus(statusUrl, (online) => {
        if (online) setDisconnected(false);
      });

    run();
    const id = window.setInterval(run, 10_000);
    return () => window.clearInterval(id);
  }, [disconnected, statusUrl, setDisconnected]);

  return apiReachable;
};

const ServerStatusComponent: React.FC<{
  url: string;
  renderLoading: ReactNode;
  renderOnline: ReactNode;
  renderOffline: ReactNode;
}> = ({ url, renderOffline, renderOnline, renderLoading }) => {
  const isServerOnline = useServerStatus(url);

  return (
    <div>
      {isServerOnline === null
        ? renderLoading
        : isServerOnline
        ? renderOnline
        : renderOffline}
    </div>
  );
};

export default ServerStatusComponent;
